export default "__VITE_ASSET__CDPasRyZ__"